/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Ai_IngestInputs */

const en_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Camera Wizard`)
};

const es_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistente de cámara IA`)
};

const fr_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant Caméra IA`)
};

const de_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Kamera-Assistent`)
};

const ja_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIカメラウィザード`)
};

const zh_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 相机向导`)
};

const ar_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساعد الكاميرا بالذكاء الاصطناعي`)
};

const id_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wizard Kamera AI`)
};

const it_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistente Fotocamera IA`)
};

const ru_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ Мастер Камеры`)
};

const pt_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistente de Câmera IA`)
};

const ko_pricing_feature_ai_ingest = /** @type {(inputs: Pricing_Feature_Ai_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 카메라 마법사`)
};

/**
* | output |
* | --- |
* | "AI Camera Wizard" |
*
* @param {Pricing_Feature_Ai_IngestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_ai_ingest = /** @type {((inputs?: Pricing_Feature_Ai_IngestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Ai_IngestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_ai_ingest(inputs)
	if (locale === "es") return es_pricing_feature_ai_ingest(inputs)
	if (locale === "fr") return fr_pricing_feature_ai_ingest(inputs)
	if (locale === "de") return de_pricing_feature_ai_ingest(inputs)
	if (locale === "ja") return ja_pricing_feature_ai_ingest(inputs)
	if (locale === "zh") return zh_pricing_feature_ai_ingest(inputs)
	if (locale === "ar") return ar_pricing_feature_ai_ingest(inputs)
	if (locale === "id") return id_pricing_feature_ai_ingest(inputs)
	if (locale === "it") return it_pricing_feature_ai_ingest(inputs)
	if (locale === "ru") return ru_pricing_feature_ai_ingest(inputs)
	if (locale === "pt") return pt_pricing_feature_ai_ingest(inputs)
	return ko_pricing_feature_ai_ingest(inputs)
});